import { _apiV2_Interval } from "@/app/api2"

// INDUSTRY METRICS FOR INTERVAL
export async function apiv2_getIndustryInterval(
  interval: string,
  filter: string
) {
  return _apiV2_Interval({
    url: `/industry/${interval}`,
    interval,
    options: {
      key: `getIndustryInterval(${interval})`,
      cacheLS: true,
      queryParam: { filter },
    },
  })
}

// CATEGORY METRICS FOR INTERVAL
export async function apiv2_getCategoryInterval(
  categoryId: string,
  interval: string,
  filter: string
) {
  return _apiV2_Interval({
    url: `/categories/${categoryId}/${interval}`,
    interval,
    options: {
      key: `getCategoryInterval(${categoryId}, ${interval})`,
      cacheLS: true,
      queryParam: { filter },
    },
  })
}

// FUND METRICS FOR INTERVAL
export async function apiv2_getFundInterval(
  fundId: string,
  interval: string,
  filter: string
) {
  const key = `getFundInterval(${fundId}, ${interval})`

  return _apiV2_Interval({
    url: `/funds/${fundId}/${interval}`,
    interval,
    options: {
      key,
      cacheLS: true,
      queryParam: { filter },
    },
  })
}

// FIRM METRICS FOR INTERVAL
export async function apiv2_getFirmInterval(
  firmId: string,
  interval: string,
  filter: string
) {
  const key = `getFirmInterval(${firmId}, ${interval})`

  return _apiV2_Interval({
    url: `/firms/${firmId}/${interval}`,
    interval,
    options: {
      key,
      cacheLS: true,
      queryParam: { filter },
    },
  })
}
